import { Theme } from "../component/navigation/ThemeDropdown";

export default function ToolSelectionIcon({
    theme,
    isOpen,
}: {
    theme: Theme;
    isOpen: boolean;
}) {
    return (
        <svg
            width="10"
            height="8"
            viewBox="0 0 6 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.98633 1L0.986328 5L4.98633 9"
                stroke={
                    isOpen
                        ? "#2D3748"
                        : theme === "light"
                          ? "#535353"
                          : "#7A8690"
                }
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
